const defaultOpeningClosingTime = [
  {
    id: 1,
    dayOfWeek: "Sunday",
    allowed24Hour: true,
    openingTime: "06:00 AM",
    closingTime: "10:00 PM",
    closed: false,
  },
  {
    id: 2,
    dayOfWeek: "Monday",
    allowed24Hour: false,
    openingTime: "06:00 AM",
    closingTime: "10:00 PM",
    closed: false,
  },
  {
    id: 3,
    dayOfWeek: "Tuesday",
    allowed24Hour: false,
    openingTime: "06:00 AM",
    closingTime: "10:00 PM",
    closed: false,
  },
  {
    id: 4,
    dayOfWeek: "Wednesday",
    allowed24Hour: false,
    openingTime: "06:00 AM",
    closingTime: "10:00 PM",
    closed: false,
  },
  {
    id: 5,
    dayOfWeek: "Thursday",
    allowed24Hour: false,
    openingTime: "06:00 AM",
    closingTime: "10:00 PM",
    closed: false,
  },
  {
    id: 6,
    dayOfWeek: "Friday",
    allowed24Hour: false,
    openingTime: "06:00 AM",
    closingTime: "10:00 PM",
    closed: false,
  },
  {
    id: 7,
    dayOfWeek: "Saturday",
    allowed24Hour: false,
    openingTime: "06:00 AM",
    closingTime: "10:00 PM",
    closed: false,
  },
];

const allWeekDays = [
  { name: "Sunday", value: "Sunday" },
  { name: "Monday", value: "Monday" },
  { name: "Tuesday", value: "Tuesday" },
  { name: "Wednesday", value: "Wednesday" },
  { name: "Thursday", value: "Thursday" },
  { name: "Friday", value: "Friday" },
  { name: "Saturday", value: "Saturday" },
];
const countries = [
  { name: "India", dialCode: "+91", countryCode: "IN" },
  { name: "Saudi Arabia", dialCode: "+966", countryCode: "SA" },
];


const defaultStartTime = {
  hours: 12,
  minutes: 0,
  period: "AM",
};

const defaultEndTime = {
  hours: 12,
  minutes: 30,
  period: "AM",
};

export {
  defaultOpeningClosingTime,
  countries,
  allWeekDays,
  defaultStartTime,
  defaultEndTime,
};
